function useGetTopRelativePosition(element: HTMLElement): number {
  return element.getBoundingClientRect().top;
}

function useGetBottomRelativePosition(element: HTMLElement): number {
  return element.getBoundingClientRect().bottom;
}

export { useGetTopRelativePosition, useGetBottomRelativePosition };
